<script>
    import {
        health, energy, hygiene, culture,
        iq, loneliness, confidence, stress,
        honesty, optimism, fitness,
        modal
    } from './stores.js';

</script>

<style>

</style>

<div>
    <h1>
        You died of exhaustion
    </h1>
</div>
